module.exports = __webpack_public_path__ + "ab1.no1.e503529f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ab1.no1.jpg
// module id = qW+w
// module chunks = 0